import { render, staticRenderFns } from "./ConsignacaoFormDialog.vue?vue&type=template&id=6ead4c80&"
import script from "./ConsignacaoFormDialog.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConsignacaoFormDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports